// Copyright ID Business Solutions Ltd. 2025

/**
 * Allows native browser features to be easily stubbed in tests.
 * See https://glebbahmutov.com/blog/stub-location/ for more details
 */
export const Native = {
  getHref: () => window.location.href,

  getHash: () => window.location.hash,

  getHostname: () => window.location.hostname,

  getPathname: () => window.location.pathname,

  setHash(hash: string) {
    window.location.hash = hash;
  },

  windowOpener: () => {
    return window.opener;
  },

  back: () => {
    window.history.back();
  },
};
